// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from 'firebase/auth';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyBJUtI-Nt4zARTT3NP9KNTpr6kxsVGu_IQ",
    authDomain: "evwhere-36d63.firebaseapp.com",
    databaseURL: "https://evwhere-36d63.firebaseio.com",
    projectId: "evwhere-36d63",
    storageBucket: "evwhere-36d63.firebasestorage.app",
    messagingSenderId: "958167048682",
    appId: "1:958167048682:web:5843c0bc24b2a340aed293",
    measurementId: "G-397H5QW3C5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);